module.exports = __webpack_public_path__ + "static/full-19e3ca681cabe64afc5e0ec361325cb2.gif";